import { FC, ReactNode } from 'react';
import { ViewResolver } from '@Components/ViewResolver';
import SheetDesktopLayout from './desktop/SheetDesktopLayout';
import SheetMobileLayout from './mobile/SheetMobileLayout';

interface SheetLayoutProps {
  children: ReactNode;
  header: ReactNode;
}

const SheetLayout: FC<SheetLayoutProps> = (props) => {
  return (
    <ViewResolver
      desktop={<SheetDesktopLayout {...props} />}
      mobile={<SheetMobileLayout {...props} />}
    />
  );
};

export default SheetLayout;
